<template>
    <div class="card-body">
        <div class="habit-page">
            <div class="row mt-2">
                <div class="col-lg-11 col-11 mx-auto">
                    <div class="card card-widget widget-user">
                        <div class="widget-user-header text-white"
                                    style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                            <h2 class="widget-user-username text-left">How am I acting on the Plan.</h2>
                            <h2 class="widget-user-desc text-right">For Version 2.0 of You.</h2>
                            <h3 class="widget-user-username text-right">The power of Consistent Action.</h3>
                        </div>
                        <div class="widget-user-image">
                            <img class="img-circle" src="/assets/images/artist128x128.png" alt="User Avatar">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-primary col-sm-12 col-12 mx-auto">
            <div class="card-header">
            <h5 class="card-title text-center">Your Future-Self Daily-Review Performance</h5>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
                </button>
            </div>
            </div>
            <div class="card-body">
            <div class="chart">
            <div class="chart-container" style="position: relative; height:40vh;">
            <!-- style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;" -->
                <canvas class="mx-auto" id="selfEvaluatedEffort" ></canvas>
            </div>
            </div>
            </div>
        </div>

 <div class="card card-primary col-sm-12 col-12 mx-auto">
            <div class="card-header">
            <h5 class="card-title text-center">Honourable Mentions: Big Streaks for Your Future-Self Daily Reviews:</h5>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
                </button>
            </div>
            </div>
            <div class="card-body">
            <div class="chart">
            <div style="position: relative; height:60vh;">
            <table class="table table-striped table-dark table-bordered">
            <tbody>
            <tr v-for="(myfstrk, index) in visionReviewTrackingData" :key="index" >
                <td v-html="formatStreakDisplayHeader(myfstrk)"></td> <td v-html="formatStreakDisplayKudos(myfstrk)"></td></tr>
            </tbody>
            </table>
            </div>
            </div>
            </div>
        </div>



        <!-- <div class=" content modal-body">
          <div class="embed-responsive embed-responsive-16by9 ">
            <div class="card mx-auto col-10" style="background: #fff; border:3px solid #fff; ">
                <h5 class="text-center"  >Your Overall Future-Self (Weighted) Streak: </h5>
                <div  class="card col-8 mx-auto p-2 mt-2 d-flex justify-content-center svg-container">

            </div>
            </div>

            <div  class="card col-10 mx-auto" style="background: #e8f2e3;" v-if="lifeAreas.length>0">
                <h5  class="header-box-msg  text-center">Your Self-Evaluated Performance on your Future-Self Life-Areas:</h5>
                <div   class="card col-8 mx-auto p-2 mt-2 d-flex justify-content-center svg-container">
                    <h6 class="text-center"> <b>Life-Area:</b><br/><em></em></h6>

                </div>

                <div class="row d-flex justify-content-between" >
                    <div class="col-sm-4 col-md-2 bordered"  v-for="lifearea in allLifeAreasData" :key="lifearea.life_area">
                        <h4 >{{lifearea.life_area}}</h4>
                        <div class="color-palette-set">
                           <button class="btn btn-warning btn-sm mb-2"  @click="displayLifeAreaDOYSVG(lifearea.life_area)">Display My Performance <i class="fas fa-eye fai-blue"></i></button>
                        </div>
                    </div>

                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import Errors from '../partials/Errors.vue';
import Chart from 'chart.js';
import { transparentize} from '../../chart/ChartUtils';
var _ = require('lodash');
export default {
    components: { Errors, },
    name: "FutureMeResultsNew",
    data() {
        return {
            userData:[],
            currentlifearea:'',
            currentlifeareadata:[],
            allLifeAreasData:'',
            visionReviewTrackingData:'',
            lifeAreas:'',
            chartData:'',
        }
    },
    props: {
        userdata:'',
        tracking:'',
        myfsdetails: '',

    },
    mounted() {
        this.userData = JSON.parse(this.userdata);
        this.allLifeAreasData = JSON.parse(this.myfsdetails);
        this.visionReviewTrackingData = JSON.parse(this.tracking);
        this.lifeAreas = JSON.parse(this.myfsdetails);
        this.createCompositeChart();
    },
    methods: {
        formatStreakDisplayHeader(myfstrk){
            const streakHeading = `${this.formatDateShort(myfstrk.created_at)} - ${this.formatDateShort(myfstrk.updated_at)}`;
        return  streakHeading + ': ';
        },

        formatStreakDisplayKudos(myfstrk){
            const numStars = Math.floor(myfstrk.attempt_count / 10);
            const starHtmlString = `<img src='/images/yays/yellow-gold-star85.png'>`;
            var finalHtml = '';
            if(numStars < 5) {
                for(var i=1; i<=numStars; i++) {
                    finalHtml +=starHtmlString;
                }
            } else {
                finalHtml += `<h4>`+numStars + ' stars!: '+ `<img style="width:200px;" src='/images/yays/rugby-yay.gif'></h4>`;
            }
        return  finalHtml;
        },

        formatDateShort(dateString) {
            const date = new Date(dateString);
            const formattedDate =  date.toLocaleDateString('en', {
            day: '2-digit',
            month: 'short'
            });
            // console.error(formattedDate);
            return formattedDate;
        },

        prepareChartData() {
        const labels = this.visionReviewTrackingData.map((row) => `${this.formatDateShort(row.created_at)} - ${this.formatDateShort(row.updated_at)}`);
        const attemptCounts = this.visionReviewTrackingData.map((row) => row.attempt_count);

        var chartData = {
            labels,
            datasets: [
                {
                    // label: 'Streak',
                    label: 'Streak',
                    data: attemptCounts,
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                },
            ],
        };
        return chartData;
        },

        createCompositeChart() {
            //
            // console.error('Creating Composite Chart.......................');
            var chartData = this.prepareChartData();
            // console.error(chartData);
            var chartInput = this.generateInputN(chartData.labels, chartData.datasets);
            // console.error(chartInput);
            const ctx = document.getElementById('selfEvaluatedEffort');
            new Chart(ctx, chartInput); //hung new char on ctx
        },

        generateInputN(labels, datasets) {
            var input = {};
            var data= {
            labels:labels,
            datasets:datasets
            };
            var options = this.generateConfig('line', 'My Future-Self Vision Review Performance');
            console.error(options);
            input.data= data;
            input.type= 'line';//is the shape command bar, doughnut,line,  etc,
            input.options= options;
            // console.error(input);
            return input;
        },

        generateConfig(charttype, text ) {
            var config = {
                    // type: charttype,
                    options: {
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'top',
                        },
                        title: {
                            display: true,
                            text: text
                        }
                    }
                }
            };
            return config;
        },

        cancel() {
            $('div#display-results-modal').modal('hide');
        },


    },

}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.chart-container {
position: relative;
height:30vh;
width:40vw;
    @media only screen and (max-width: 768px) {
        height:40vh;
        width:80vw;
    }
}

/* svg {
      width:  auto;
      height: auto;
} */
.svg-container {
 width: 100%;
 height: 150px;
 resize: both;
 overflow: auto;
 border: 1px dashed #aaa;
}
.bordered{
border: .5px solid rgb(193, 191, 191);
border-radius: 4px;
padding: 8px;
margin: 8px;
background: #d9e7f4;
}


svg {
@media screen {max-width: 768px;


  /* transform: rotate(45deg) rotate(-45deg); */
 /* transform: rotate(90deg) ; */
  /* transform-origin: 50% 50%; Chrome, Firefox behaves differently */
}
}
</style>
